module.exports = __webpack_public_path__ + "img/quxiao1_h5.f7f9900.jpg";